import getWidthCode from '@/utils/viewSize';

function setViewSize({ commit }, width) {
  const code = getWidthCode(width);
  commit('SET_VIEW_SIZE', code);
}

function setGlobalError({ commit }, flag) {
  commit('SET_GLOBAL_ERROR', flag);
}

function setOperationError({ commit }, name) {
  commit('SET_OPERATION_ERROR', name);
}

export default {
  changeViewSize: ({ commit }, width) => setViewSize({ commit }, width),
  setGlobalError: ({ commit }, flag) => setGlobalError({ commit }, flag),
  setOperationError: ({ commit }, name) => setOperationError({ commit }, name),
};



// WEBPACK FOOTER //
// ./src/store/actions.js